import { render, staticRenderFns } from "./Ckeditor.vue?vue&type=template&id=f03f7c52&scoped=true"
import script from "./Ckeditor.vue?vue&type=script&lang=js"
export * from "./Ckeditor.vue?vue&type=script&lang=js"
import style0 from "./Ckeditor.vue?vue&type=style&index=0&id=f03f7c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03f7c52",
  null
  
)

export default component.exports